import {
  CHATBOTS_BUTTONS_CONTROLLER_EDITFORM_CHANGE, CHATBOTS_BUTTONS_CONTROLLER_EDITFORM_FAIL,
  CHATBOTS_BUTTONS_CONTROLLER_EDITFORM_LOAD,
  CHATBOTS_BUTTONS_CONTROLLER_EDITFORM_SUCEED, CHATBOTS_BUTTONS_CONTROLLER_ENTER_RESET,
  CHATBOTS_BUTTONS_CONTROLLER_FETCH_ITEMS_FAIL,
  CHATBOTS_BUTTONS_CONTROLLER_FETCH_ITEMS_LOAD,
  CHATBOTS_BUTTONS_CONTROLLER_FETCH_ITEMS_SUCCEED,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case CHATBOTS_BUTTONS_CONTROLLER_FETCH_ITEMS_LOAD:
      return {
        ...state,
        isFetcChatbotsButtonsControllerLoading: true,
        fetchChatbotsButtonsControllerErrors: null,
      }
    case CHATBOTS_BUTTONS_CONTROLLER_FETCH_ITEMS_SUCCEED:
      return {
        ...state,
        isFetcChatbotsButtonsControllerLoading: false,
        items: action.items,
      }
    case CHATBOTS_BUTTONS_CONTROLLER_FETCH_ITEMS_FAIL:
      return {
        ...state,
        isFetcChatbotsButtonsControllerLoading: false,
        items: null,
        fetchChatbotsButtonsControllerErrors: action.fetchButtonMenuItemsError,
      }
    case CHATBOTS_BUTTONS_CONTROLLER_EDITFORM_CHANGE:
      return {
        ...state,
        isFetcChatbotButtonsLoading: false,
        formFieldButtonMenuValues: {

        },
      }
    case CHATBOTS_BUTTONS_CONTROLLER_EDITFORM_LOAD:
      return { ...state }
    case CHATBOTS_BUTTONS_CONTROLLER_EDITFORM_SUCEED:
      return { ...state }
    case CHATBOTS_BUTTONS_CONTROLLER_EDITFORM_FAIL:
      return { ...state }
    case CHATBOTS_BUTTONS_CONTROLLER_ENTER_RESET:
      return { ...state }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/chatbotsButtonsController.js